// The plans, in one place: /pricing draws the full cards, the home page a short summary of each
// (2026-10-15). Change a price or a benefit here and both pages follow.
//
// What a paid plan adds must be something that costs us real money to run in the cloud
// (see the note under the cards on /pricing). Storage numbers match `config/quotas`.

export const plans = [
  {
    id: 'free', name: 'Free', price: '$0', period: '',
    summary: 'Local AI with your own keys, and sync across your devices.',
    features: [
      '50 published items',
      '25 MB cloud storage',
      '500 MB bandwidth/mo',
      'Local AI (your own API keys)',
      'iCloud sync across your devices',
    ],
    cta: 'Current Plan', disabled: true,
  },
  {
    id: 'creator', name: 'Creator', price: '$9.95', period: '/month',
    summary: 'Publish privately, 1 GB of cloud storage, compute tokens, and iPhone check-ins that wait for your Mac.',
    features: [
      'Unlimited published items',
      'Public, unlisted, or private',
      '1 GB cloud storage',
      '25 GB bandwidth/mo',
      '$1.00 / mo of compute tokens',
      // 2026-10-15: the offline lane. The iPhone asks and saves check-ins (and answers to
      // assistant questions) while the Mac is asleep; the Mac logs them when it is back.
      'iPhone check-ins while your Mac is offline',
      'Everything in Free',
    ],
    cta: 'Choose Creator', highlight: true,
  },
  {
    id: 'pro', name: 'Pro', price: '$19.95', period: '/month',
    summary: 'Everything in Creator, with 5 GB of storage, more compute tokens and priority support.',
    features: [
      'Unlimited published items',
      '5 GB cloud storage',
      '50 GB bandwidth/mo',
      '$3.00 / mo of compute tokens',
      'Priority support',
      'Everything in Creator',
    ],
    cta: 'Choose Pro',
  },
];

/** The lowest paid price, for "plans from $9.95/month". */
export const lowestPaidPrice = plans.find((p) => p.id === 'creator').price;
